import { render, staticRenderFns } from "./px-tabs-mobile.vue?vue&type=template&id=f41273a0&"
import script from "./px-tabs-mobile.vue?vue&type=script&lang=ts&"
export * from "./px-tabs-mobile.vue?vue&type=script&lang=ts&"
import style0 from "./px-tabs-mobile.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports